export enum ApiType {
	AGILOX = 'agilox',
	LEGACY = 'legacy',
	CONTAO = 'contao',
	GRAPH = 'graph',
}
